"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var HDMI = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_HDMI_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 5h12V4H2v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1a2 2 0 0 0-2 2v6h16V3a2 2 0 0 0-2-2H2Zm12 1H2a1 1 0 0 0-1 1v5h14V3a1 1 0 0 0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.264 15V9.645H1.47v2.048h1.125V9.645h1.2V15h-1.2v-2.235H1.471V15H.264Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24 15V9.645h1.553c.445 0 .82.105 1.125.315.31.205.545.497.705.877.165.38.248.838.248 1.373 0 .585-.093 1.087-.278 1.507-.18.415-.43.733-.75.953-.315.22-.677.33-1.087.33H4.24Zm1.426-1.057c.34 0 .587-.148.742-.443.16-.295.24-.693.24-1.193 0-.364-.035-.665-.105-.9-.07-.235-.172-.41-.307-.524a.74.74 0 0 0-.51-.18h-.308v3.24h.248Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12 9.645V15h1.035l-.015-1.185c0-.07-.005-.192-.015-.367a278.072 278.072 0 0 1-.082-1.328 101.1 101.1 0 0 0-.083-1.252c-.01-.15-.015-.24-.015-.27h.06l.405 3.127h1.185L11 10.598h.06c0 .03-.007.12-.022.27-.01.144-.025.327-.045.547-.015.22-.033.455-.053.705l-.045.72c-.015.23-.03.433-.045.607-.01.176-.015.296-.015.36L10.828 15h1.02V9.645h-1.59l-.24 3.15h-.023l-.262-3.15H8.12ZM12.42 15v-.885l.967-.113v-3.36l-.967-.112v-.885h3.082v.885l-.937.113v3.36l.937.112V15H12.42Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_HDMI_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = HDMI;
exports["default"] = _default;